import React from "react";
import * as S from "./styles";
export var RatingsBar = function RatingsBar(_ref) {
  var e = _ref.title,
      t = _ref.reviewCount,
      a = _ref.reviewTotal,
      r = _ref.className;
  var n = t / a * 100,
      l = "".concat(t > 0 && 0 === Math.round(n) ? "<1" : Math.round(n), "%");
  return React.createElement(S.RatingsBarContainer, {
    className: r
  }, React.createElement(S.RatingsBarTitle, null, e), React.createElement(S.RatingsBar, null, React.createElement(S.RatingsBarOverlay, {
    ratingsPercentage: n
  })), React.createElement(S.RatingsPercentage, null, l));
};
export default RatingsBar;